import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';
import {
  navbarHeight,
  sidebarLaptopWidth,
  sidebarTabletWidth,
} from '../../../constants/styles-vars';

export const sidebarTransition = 'width 0.2s ease-in-out';

export const sidebarWrapper = style({
  position: 'fixed',
  bottom: 0,
  ...responsiveStyle({
    mobile: {
      width: '100%',
      height: navbarHeight,
      borderTop: `1px solid ${themeVars.nav.border}`,
    },
    tablet: {
      borderTop: 'unset',
      width: sidebarTabletWidth,
      height: '100%',
      borderRight: `1px solid ${themeVars.nav.border}`,
    },
    laptop: {
      width: sidebarLaptopWidth,
      transition: sidebarTransition,
    },
  }),
});

export const sidebarWrapperCollapsed = style({
  selectors: {
    '&:is(&)': {
      width: sidebarTabletWidth,
      height: '100%',
      transition: sidebarTransition,
    },
  },
});

export const sidebarInner = style({
  width: '100%',
  height: '100%',
  overflowX: 'hidden',
  gridArea: 'sidebar',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: themeVars.nav.base,

  ...responsiveStyle({
    mobile: {
      paddingBottom: 'env(safe-area-inset-bottom)',
      overflowY: 'hidden',
    },
    tablet: {
      padding: `${space.s10}px ${space.s16}px`,
      overflowY: 'auto',
    },
    laptop: {
      padding: `${space.s10}px ${space.s16}px`,
    },
    desktop: {
      padding: `${space.s10}px ${space.s16}px`,
    },
  }),
});

export const sidebarBody = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s40,
  width: '100%',

  ...responsiveStyle({
    laptop: {
      alignItems: 'initial',
    },
  }),
});

export const sidebarDrawerContent = style({
  padding: space.s40,
  width: 326,
});

export const sidebarCollapseButtonContainer = style({
  position: 'absolute',
  top: '36px',
  right: -space.s16,
});

export const sidebarCollapseButtonTooltipContent = style({
  padding: `${space.s8}px ${space.s16}px`,
});

export const sidebarCollapseButtonTooltipArrow = style({
  height: 6,
  width: 10,
});

export const sidebarGuestAuthButtons = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s8,
    margin: `0 ${space.s24}px`,
  },
]);
